import { render, staticRenderFns } from "./menu-header-options.component.vue?vue&type=template&id=e3f025c6&"
import script from "./menu-header-options.component.vue?vue&type=script&lang=ts&"
export * from "./menu-header-options.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports